import React, { useContext, useEffect, useState } from "react";
import AuthenticationContext from "./AuthenticationContext";
import { useNotification } from "./NotificationProvider";
import {
  hasBeenNotificationPrompted,
  markNotificationPrompted
} from "../../constants/browserNotifications";
import { BrowserNotificationService } from "../../services/BrowserNotificationService";
import { TranslationService } from "../../services/TranslationService";
import CompanyService from "../../services/CompanyService";

export const NotificationPermissionPrompt: React.FC = () => {
  const { isAuthenticated } = useContext(AuthenticationContext);
  const { permission, isSupported, requestPermission } = useNotification();
  const [visible, setVisible] = useState(false);
  const [requesting, setRequesting] = useState(false);
  const allowChatbot = CompanyService.canUseWhatsappNotifications();

  useEffect(() => {
    if (
      isAuthenticated &&
      isSupported &&
      allowChatbot &&
      permission === "default" &&
      !hasBeenNotificationPrompted()
    ) {
      const timer = setTimeout(() => setVisible(true), 2000);
      return () => clearTimeout(timer);
    }
  }, [isAuthenticated, isSupported, allowChatbot, permission]);

  const handleAllow = async () => {
    setRequesting(true);
    try {
      const result = await requestPermission();
      markNotificationPrompted();
      if (result === "granted") {
        await BrowserNotificationService.showPermissionGrantedNotification();
      }
    } finally {
      setRequesting(false);
      setVisible(false);
    }
  };

  const handleDismiss = () => {
    markNotificationPrompted();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: "1.5rem",
        left: "1.5rem",
        zIndex: 1055,
        boxShadow: "0 4px 16px rgba(0,0,0,.18)"
      }}
      className="card border-0"
      role="dialog"
      aria-label="Solicitud de notificaciones"
    >
      <div className="card-body">
        <div className="d-flex align-items-start gap-2 mb-2">
          <i className="fa fa-bell text-primary mt-1" />
          <p
            className="mb-0 small"
            style={{
              maxWidth: "300px"
            }}
          >
            {TranslationService.translate?.NotificationPromptMessage ||
              "Intiza puede avisarte cuando lleguen mensajes de WhatsApp, incluso si estás en otra pestaña."}
          </p>
        </div>
        <div className="d-flex gap-2 justify-content-end">
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={handleDismiss}
          >
            {TranslationService.translate?.NotificationPromptDismiss ||
              "No, gracias"}
          </button>
          <button
            type="button"
            className="btn btn-primary  btn-sm"
            onClick={handleAllow}
            disabled={requesting}
          >
            <i className="fa fa-bell me-1" />
            {requesting
              ? TranslationService.translate?.NotificationsEnabling ||
                "Habilitando..."
              : TranslationService.translate?.NotificationPromptAllow ||
                "Activar notificaciones"}
          </button>
        </div>
      </div>
    </div>
  );
};
